/* SourceToHome: public product-list selections through the existing Google tag. */
(() => {
  'use strict';
  if (window.__sthSelectItemBound ||
      !['https://sourcetohome.com', 'https://www.sourcetohome.com'].includes(location.origin) ||
      !/^\/(?:$|collections(?:\/[^/]+)?\/?$|products\/[^/]+\/?$)/.test(location.pathname)) return;
  window.__sthSelectItemBound = true;

  const cards = '.dw-card[data-product-id], .sth-discovery-card[data-product-id], .product-card[data-product-id]';
  const handled = new WeakSet();
  function selected(event) {
    if (!event.isTrusted || event.defaultPrevented || handled.has(event) ||
        (event.type === 'click' ? event.button !== 0 : event.button !== 1) ||
        !(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.closest('form, label, [data-quickshop]')) return;
    const card = anchor.closest(cards);
    if (!card) return;
    const productId = card.getAttribute('data-product-id');
    if (!/^[1-9]\d{0,19}$/.test(productId || '')) return;

    try {
      const target = new URL(anchor.getAttribute('href'), location.origin);
      if (target.origin !== location.origin ||
          !/^\/(?:collections\/[^/]+\/)?products\/[a-z0-9][a-z0-9-]*\/?$/.test(target.pathname)) return;
      // Read current permission at the actual action; never queue or replay denied actions.
      if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' ||
          window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true ||
          typeof window.gtag !== 'function') return;
      handled.add(event);
      const listId = card.classList.contains('dw-card') ? 'sth_discover_wall' :
        card.classList.contains('sth-discovery-card') ? 'sth_product_discovery' : 'sth_product_cards';
      window.gtag('event', 'select_item', {
        send_to: 'G-M9E7641971',
        item_list_id: listId,
        items: [{item_id: productId}],
        transport_type: 'beacon',
        page_location: location.origin + location.pathname,
        page_referrer: '',
      });
    } catch (_) {
      // An unavailable/blocked analytics integration must not affect shopping.
    }
  }
  // Capture precedes the existing veil's legitimate bubble-phase navigation interception.
  document.addEventListener('click', selected, {capture: true, passive: true});
  document.addEventListener('auxclick', selected, {capture: true, passive: true});
})();
